import { Helmet } from 'react-helmet';
import QuetdtctDetail
  from 'src/components/quetdtct-detail/QuetdtctDetail';
  import UploadListToolbar from 'src/components/quetdtct-detail/UploadListToolbar';
import {
  Box,
  Container,
} from '@material-ui/core';

const Quetdtct = () => (
  <>
    <Helmet>
      <title>Quét đối tượng chương trình</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
      <UploadListToolbar />
        <Box sx={{ pt: 3 }}>
          <QuetdtctDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Quetdtct;
